import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import OutsideClickHandler from 'react-outside-click-handler';

import './Typeahead.scss';
import Search from '../../components/Search/Search';
import { fetchTypeaheadResults,clearGlobalSearch } from '../../store/actions/typeahead';
import { selectTypeaheadResults, selectTypeaheadValue } from '../../store/selectors/typeahead';
import TypeaheadResult from './TypeaheadResult';
import { setSearch, clearSearch } from '../../store/actions/search';
import { selectSearch } from '../../store/selectors/search';
import { selectAuthenticatedUser } from '../../store/selectors/auth';

class Typeahead extends Component {
  render() {
    const { onFetchTypeaheadResults, results, value,setSearch,clearSearch,search,user,clearGlobalSearch } = this.props;
    
    return (
      <OutsideClickHandler
        onOutsideClick={() => {
          clearGlobalSearch()
          // if(search.all){
          //   setSearch({ all: ''})
          //   onFetchTypeaheadResults(user.id,user.roles[0].role.name,'');
          // }
          
        }}
      >
        <div className="typeahead">
          <Search
            theme="dark"
            onChange={e => onFetchTypeaheadResults(user.id,user.roles[0].role.name,e.target.value)}
            // onChange={e => {setSearch({ all: e.target.value})}}
            value={value}
          />
          {value && results.length > 0 && (
            <div className="typeahead__results">
              {results.map(result => (
                <TypeaheadResult
                  result={result}
                  // onClick={() => onFetchTypeaheadResults(user.id,user.roles[0].role.name,'')}
                />
              ))}
            </div>
          )}
        </div>
      </OutsideClickHandler>
    )
  }
}

const mapStateToProps = state => ({
  user:selectAuthenticatedUser(state),
  results: selectTypeaheadResults(state),
  value: selectTypeaheadValue(state),
  search:selectSearch(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchTypeaheadResults: fetchTypeaheadResults,
  setSearch,
  clearSearch,
  clearGlobalSearch
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Typeahead);
